module.exports = __webpack_public_path__ + "img/home.bb0a3fbe.svg";